import { number, object, string } from "yup";

import { SOCIAL_TYPES } from "../types";

const re =
    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

export const domainSchema = () => {
    const schema = {
        domain_name: string().required().matches(re, "URL is not valid"),
        //amazeKey: string().required(),
    };

    return object().shape(schema);
};

export const botSchema = () => {
    const schema = {
        name: string().required(),
        description: string().nullable(),
        character_id: string().required(),
        knowledge_id: string(),
        project_id: string().required(),
        channel_id: string().required(),
        social_media: number().oneOf(Object.values(SOCIAL_TYPES).map((value) => Number(value))),
    };
    return object().shape(schema);
};

// Re-export module-specific validations for backward compatibility
export { facebookAccSchema } from "../facebook/validations";
export {
    adValidationSchema,
    AppSettingsSchema,
    backgroundValidationSchema,
    characterAvatarValidationSchema,
    festivalValidationSchema,
    greetingValidationSchema,
    hintValidationSchema,
    kioskConfigSchema,
    languageSettingsSchema,
    photoFilterValidationSchema,
    qrcodeValidationSchema,
    volumeValidationSchema,
} from "../kiosk/validations";
export { lineAccSchema } from "../line/validations";
